export const campus = document.querySelector('#survey-app')?.getAttribute('data-campus');
